import { render, staticRenderFns } from "./ForestShop.vue?vue&type=template&id=4015f2b3&scoped=true"
import script from "./ForestShop.vue?vue&type=script&lang=js"
export * from "./ForestShop.vue?vue&type=script&lang=js"
import style0 from "./ForestShop.vue?vue&type=style&index=0&id=4015f2b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4015f2b3",
  null
  
)

export default component.exports